<template>
  <div id="app">
    <!-- 全局返回按钮 -->
    <BackButton />
    <router-view/>
  </div>
</template>

<script>
import BackButton from '@/components/BackButton.vue'

export default {
  name: 'App',
  components: {
    BackButton
  }
}
</script>

<style>
#app {
  height: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: var(--color-divider-background);
}
</style>
